import get from 'lodash/get'
import settings from 'settings'
import zipObject from 'lodash/zipObject'

export const getLanguagesMap = (languages: Array<string>) => {
    const allowedLanguages = get(settings, 'clanrec2.languages', [])
    return zipObject(
        allowedLanguages,
        allowedLanguages.map((x) => languages && languages.indexOf(x) > -1)
    )
}